import axios from "axios";
import { toast } from "react-toastify";

const API_BASE_URL = process.env.REACT_APP_MAIN_URL || "http://localhost:8080";

// Action Types
export const GET_DIVISIONS_REQUEST = "GET_DIVISIONS_REQUEST";
export const GET_DIVISIONS_SUCCESS = "GET_DIVISIONS_SUCCESS";
export const GET_DIVISIONS_FAILURE = "GET_DIVISIONS_FAILURE";

export const GET_DIVISION_BY_ID_REQUEST = "GET_DIVISION_BY_ID_REQUEST";
export const GET_DIVISION_BY_ID_SUCCESS = "GET_DIVISION_BY_ID_SUCCESS";
export const GET_DIVISION_BY_ID_FAILURE = "GET_DIVISION_BY_ID_FAILURE";

export const GET_DIVISIONS_BY_SPORT_REQUEST = "GET_DIVISIONS_BY_SPORT_REQUEST";
export const GET_DIVISIONS_BY_SPORT_SUCCESS = "GET_DIVISIONS_BY_SPORT_SUCCESS";
export const GET_DIVISIONS_BY_SPORT_FAILURE = "GET_DIVISIONS_BY_SPORT_FAILURE";

export const ADD_DIVISION_REQUEST = "ADD_DIVISION_REQUEST";
export const ADD_DIVISION_SUCCESS = "ADD_DIVISION_SUCCESS";
export const ADD_DIVISION_FAILURE = "ADD_DIVISION_FAILURE";

export const UPDATE_DIVISION_REQUEST = "UPDATE_DIVISION_REQUEST";
export const UPDATE_DIVISION_SUCCESS = "UPDATE_DIVISION_SUCCESS";
export const UPDATE_DIVISION_FAILURE = "UPDATE_DIVISION_FAILURE";

export const DELETE_DIVISION_REQUEST = "DELETE_DIVISION_REQUEST";
export const DELETE_DIVISION_SUCCESS = "DELETE_DIVISION_SUCCESS";
export const DELETE_DIVISION_FAILURE = "DELETE_DIVISION_FAILURE";

export const SEARCH_DIVISIONS_REQUEST = "SEARCH_DIVISIONS_REQUEST";
export const SEARCH_DIVISIONS_SUCCESS = "SEARCH_DIVISIONS_SUCCESS";
export const SEARCH_DIVISIONS_FAILURE = "SEARCH_DIVISIONS_FAILURE";

// Get All Divisions
export const GetDivisions = (page = 0, token) => async (dispatch) => {
  dispatch({ type: GET_DIVISIONS_REQUEST });
  try {
    const response = await axios.get(`${API_BASE_URL}api/divisionsMaster`, {
      params: { page, size: 10 },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: GET_DIVISIONS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: GET_DIVISIONS_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to fetch division masters");
  }
};

// Get Division By ID
export const GetDivisionById = (divisionId, token) => async (dispatch) => {
  dispatch({ type: GET_DIVISION_BY_ID_REQUEST });
  try {
    const response = await axios.get(`${API_BASE_URL}api/divisionsMaster/${divisionId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: GET_DIVISION_BY_ID_SUCCESS, payload: response.data.data });
  } catch (error) {
    dispatch({ type: GET_DIVISION_BY_ID_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to fetch division master details");
  }
};

// Get Divisions By Sport ID
export const GetDivisionsBySportId = (sportId, token) => async (dispatch) => {
  dispatch({ type: GET_DIVISIONS_BY_SPORT_REQUEST });
  try {
    const response = await axios.get(`${API_BASE_URL}api/divisionsMaster/sport/${sportId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: GET_DIVISIONS_BY_SPORT_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: GET_DIVISIONS_BY_SPORT_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to fetch divisions for sport");
  }
};

// Add Division
export const Add_Division = (divisionData, token, navigate) => async (dispatch) => {
  dispatch({ type: ADD_DIVISION_REQUEST });
  try {
    const response = await axios.post(`${API_BASE_URL}api/divisionsMaster`, divisionData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    dispatch({ type: ADD_DIVISION_SUCCESS, payload: response.data });
    toast.success("Division Added successfully!");
    navigate("/dashboard/alldivisionmasters");
  } catch (error) {
    dispatch({ type: ADD_DIVISION_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to add Division");
  }
};

// Update Division
export const Update_Division = (divisionId, divisionData, token, navigate) => async (dispatch) => {
  dispatch({ type: UPDATE_DIVISION_REQUEST });
  try {
    const response = await axios.put(
      `${API_BASE_URL}api/divisionsMaster/${divisionId}`,
      divisionData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: UPDATE_DIVISION_SUCCESS, payload: response.data });
    toast.success("Division Master updated successfully!");
    navigate("/dashboard/alldivisionmasters");
  } catch (error) {
    dispatch({ type: UPDATE_DIVISION_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to update division master");
  }
};

// Delete Division
export const DelDivision = (divisionId, token, callback) => async (dispatch) => {
  dispatch({ type: DELETE_DIVISION_REQUEST });
  try {
    await axios.delete(`${API_BASE_URL}api/divisionsMaster/${divisionId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: DELETE_DIVISION_SUCCESS });
    toast.success("Division Master deleted successfully!");
    if (callback) callback();
  } catch (error) {
    dispatch({ type: DELETE_DIVISION_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to delete division master");
  }
};

// Search Divisions
export const getDivisionsBySearch = (searchQuery, page = 0, token) => async (dispatch) => {
  dispatch({ type: SEARCH_DIVISIONS_REQUEST });
  try {
    const response = await axios.get(`${API_BASE_URL}api/divisionsMaster/search`, {
      params: { 
        name: searchQuery, 
        page, 
        size: 10 
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: SEARCH_DIVISIONS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: SEARCH_DIVISIONS_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to search division masters");
  }
};
